<claas-breadcrumb></claas-breadcrumb>
<div class="contacts-container">
  <h1 class="section-title">
    {{ "features.contacts.contactsMainTitle" | translate }}
  </h1>
  <div class="section-wrapper">
    <div class="contact-cards-list">
      @for (contact of contacts.contacts; track $index) {
        <claas-contact-card [contact]="contact"></claas-contact-card>
      }
    </div>
    <div class="support-documents">
      <div class="support-documents-header">
        <h2 class="font-2xl">
          {{ "features.contacts.supportDocumentsTitle" | translate }}
        </h2>
        <p>
          {{ "features.contacts.supportDocumentsPlaceholderText" | translate }}
        </p>
      </div>
      <claas-support-documents
        [tableData]="supportDocumentsData"
      ></claas-support-documents>
    </div>
  </div>
</div>
